import React from 'react';
 import ReactDOM from 'react-dom';
 import { Spin } from 'antd';
 import userInfo from '#/util/userInfo';
 import * as Sentry from '@sentry/react';

 import AdsLoadingIndicator from '#/component/AdsLoadingIndicator';

 import subsystem from '#/util/subsystem';
 import { isGray, isProd } from '#/util/env';
 import pageReporter from '#/util/pageReporter';
 import throat from 'throat';
 import Layout from './layout';
 import './common/style/index.scss';
 import { PRELOAD_BUNDLE } from './layout/common/constant';
 import { loadBundle } from './layout/AdsMain/utils';

 !subsystem.getDebugSubsystem().length &&
   (isProd || isGray) &&
   Sentry.init({
     environment: isGray ? 'gray' : 'production',
     dsn: 'https://278937a7a5e31b1d73dc83424410ccb7@sentry.cloudview.me/2',
     integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
     // Performance Monitoring
     tracesSampleRate: 1.0, //  Capture 100% of the transactions
     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
     tracePropagationTargets: [],
     initialScope: {
       user: {
         username: userInfo.get().username,
         id: userInfo.get().primaryAccountId,
       },
     },
     beforeSendTransaction: pageReporter.report.bind(pageReporter),

     // Session Replay
     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
     replaysOnErrorSampleRate: 1.0,
   });

 Spin.setDefaultIndicator(<AdsLoadingIndicator />);

 function render() {
   ReactDOM.render(<Layout />, document.getElementById('root'));
 }

 // 兼容Common Report和Common DB操作中从cookie取包名的历史逻辑
 function hackInitCookie() {
   try {
     const d = new Date();
     d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
     const expires = `expires=${d.toGMTString()}`;
     document.cookie = `_package_name=com.transsion.phoenix;${expires};path=/`;
   } catch (e) {
     console.error(e);
   }
 }
 // 性能优化，预加载部分 page
 function preloadBundle() {
   const timer = setTimeout(() => {
     clearTimeout(timer);
     Promise.all(PRELOAD_BUNDLE.map(throat((bundle) => loadBundle(bundle), 2)));
   }, 1500);
 }

 (function main() {
   preloadBundle();
   hackInitCookie();
   render();
 })();
